import { getSvgWithColor } from './svg-utils';
export var BACKGROUND_PATTERNS = {
    NONE: {
        key: 'none',
        getAsset: function () { return 'none'; },
        opacity: 0,
        backgroundSize: '0px 0px',
    },
    HOLIDAY1: {
        key: 'holiday1',
        opacity: 0.25,
        backgroundSize: '168px 168px',
        backgroundGroup: 'holiday',
    },
    HOLIDAY2: {
        key: 'holiday2',
        opacity: 0.15,
        backgroundSize: '168px 168px',
        backgroundGroup: 'holiday',
    },
    HOLIDAY3: {
        key: 'holiday3',
        opacity: 0.15,
        backgroundSize: '168px 168px',
        backgroundGroup: 'holiday',
    },
    HOLIDAY4: {
        key: 'holiday4',
        opacity: 0.1,
        backgroundSize: '168px 168px',
        backgroundGroup: 'holiday',
    },
    HOLIDAY5: {
        key: 'holiday5',
        opacity: 0.15,
        backgroundSize: '168px 168px',
        backgroundGroup: 'holiday',
    },
    HOLIDAY6: {
        key: 'holiday6',
        opacity: 0.15,
        backgroundSize: '168px 168px',
        backgroundGroup: 'holiday',
    },
    SQUIGGLES: {
        key: 'squiggles',
        opacity: 0.1,
        backgroundSize: '168px 168px',
    },
    CIRCLES: {
        key: 'circles',
        opacity: 0.1,
        backgroundSize: '168px 168px',
    },
    DIAGONAL: {
        key: 'diagonal',
        opacity: 0.1,
        backgroundSize: '168px 168px',
    },
    HIDEOUT: {
        key: 'hideout',
        opacity: 0.1,
        backgroundSize: '168px 168px',
    },
    LEOPARD: {
        key: 'leopard',
        opacity: 0.08,
        backgroundSize: '168px 168px',
    },
    INLAID: {
        key: 'inlaid',
        thumbnail: 'inlaid_min',
        opacity: 0.08,
        backgroundSize: '100px 100px',
        backgroundGroup: 'phase1',
    },
    POINTS: {
        key: 'points',
        thumbnail: 'points_min',
        opacity: 0.08,
        backgroundSize: '20px 20px',
        backgroundGroup: 'phase1',
    },
    SHAPES: {
        key: 'shapes',
        thumbnail: 'shapes_min',
        opacity: 0.08,
        backgroundSize: '150px 150px',
        backgroundGroup: 'phase1',
    },
    STONES: {
        key: 'stones',
        thumbnail: 'stones_min',
        opacity: 0.08,
        backgroundSize: '200px 200px',
        backgroundGroup: 'phase1',
    },
    NATURE: {
        key: 'nature',
        thumbnail: 'nature_min',
        opacity: 0.08,
        backgroundSize: '320px 320px',
        backgroundGroup: 'phase1',
    },
    TOPOGRAPHICAL: {
        key: 'topographical',
        thumbnail: 'topographical_min',
        opacity: 0.08,
        backgroundSize: '320px 320px',
        backgroundGroup: 'phase1',
    },
    GALAXY: {
        key: 'galaxy',
        thumbnail: 'galaxy_min',
        opacity: 0.08,
        backgroundSize: '320px 320px',
        backgroundGroup: 'phase1',
    },
};
export var getPatternWithColor = function (rawSvg, rgbaString) {
    return getSvgWithColor(rawSvg, rgbaString);
};
//# sourceMappingURL=background-patterns.js.map